import { type FeedbackDialogProps } from '@ori-ui/components';

export const NEWSLETTER_DIALOG = 'newsletter-dialog';
export const NEWSLETTER_DIALOG_SUBMIT = 'newsletter-dialog-submit';

export const transitionProps: FeedbackDialogProps['transitionProps'] = { timeout: 0 };
